require("font-awesome/less/font-awesome.less");
require("material-design-lite/material.min.css");
require("flag-icon-css/css/flag-icon.css");
require("./index.less");
require("./parts/freezescreen.less");